import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

function TestPage() {
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchRecord() {
      try {
        const { data, error } = await supabase
          .from('form_responses')
          .select('*')
          .eq('id', 9)
          .single();

        if (error) throw error;
        setRecord(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchRecord();
  }, []);

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>Error</h1>
        <p style={{ color: 'red' }}>{error}</p>
      </div>
    );
  }

  if (!record) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>No Record Found</h1>
        <p>Record with ID 9 was not found in the database.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Supabase Test Page</h1>
      <h2>Record ID: {record.id}</h2>

      <div style={{ marginTop: '20px' }}>
        <h3>Record Details:</h3>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          <li><strong>Title:</strong> {record.title || 'N/A'}</li>
          <li><strong>Location:</strong> {record.location || 'N/A'}</li>
          <li><strong>Country:</strong> {record.country || 'N/A'}</li>
          <li><strong>Continent:</strong> {record.continent || 'N/A'}</li>
          <li><strong>Segment:</strong> {record.segment || 'N/A'}</li>
          <li><strong>Latitude:</strong> {record.latitude || 'N/A'}</li>
          <li><strong>Longitude:</strong> {record.longitude || 'N/A'}</li>
        </ul>
      </div>

      {record.hero_image && (
        <div style={{ marginTop: '20px' }}>
          <h3>Hero Image:</h3>
          <img
            src={record.hero_image}
            alt={record.title || 'Hero image'}
            style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
          />
          <p style={{ fontSize: '12px', color: '#666', marginTop: '8px' }}>
            URL: {record.hero_image}
          </p>
        </div>
      )}

      <div style={{ marginTop: '20px' }}>
        <h3>Raw Data:</h3>
        <pre style={{
          background: '#f5f5f5',
          padding: '15px',
          borderRadius: '8px',
          overflow: 'auto',
          fontSize: '12px'
        }}>
          {JSON.stringify(record, null, 2)}
        </pre>
      </div>
    </div>
  );
}

export default TestPage;
